export default __webpack_public_path__ + "static/media/pEnerG-icon.73795dc4.png";